import r from "../managers/braze-instance.js";
import { logger as N, IndexedDBAdapter as et } from "../../shared-lib/index.js";
import ee, { STORAGE_KEYS as s } from "../managers/storage-manager.js";
export function disableSDK() {
  const e = r.nn();
  e && e.requestImmediateDataFlush();
  const n = new ee.se(null, !0),
    a = "This-cookie-will-expire-in-" + n.le();
  n.store(s.me, a);
  const i = et.Ds.Us;
  new et(i, N).setItem(i.Ls.pe, i.be, !0),
    N.info("disableSDK was called"),
    r.destroy(!1),
    r.fe(!0);
}
